module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 3",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("To the silent sufferers who need guidance, treatment, and good old TLC to face and hopefully conquer the nasty poop-related issues that plague them every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("—Susan Wong, aka Nurse Wong")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2c73a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042845/xhtml/dedication.vue
// module id = 63
// module chunks = 0